

export const unit_nGmL = 'ng/mL';
export const unit_nML = 'nM/L';
export const destinationUnit = unit_nGmL;

export function convertUnits(quantity, molecularWeight, unitFrom, unitTo) {
    if (unitFrom == unitTo) return quantity;

    if (unitFrom == unit_nGmL && unitTo == unit_nML)
        return convert_nGmL_to_nML(quantity, molecularWeight);

    if (unitFrom == unit_nML && unitTo == unit_nGmL)
        return convert_nML_to_nGmL(quantity, molecularWeight);

    return null;
}

function convert_nGmL_to_nML(quantity, molecularWeight) {
    let quantityInnML = (quantity / (molecularWeight * Math.pow(10, 9))) * Math.pow(10, 9) * 1000;
    return (Math.round(quantityInnML * 100) / 100);
}

function convert_nML_to_nGmL(quantity, molecularWeight) {
    let quantityInnGmL = (quantity * molecularWeight * Math.pow(10, 9)) / (1000 * Math.pow(10, 9));
    return (Math.round(quantityInnGmL * 100) / 100);
}

export function convertNumberToNewRange(oldValue, oldMin, oldMax, newMin, newMax) {
    let oldRange = (oldMax - oldMin);
    let newRange = (newMax - newMin);
    let newValue = (((oldValue - oldMin) * newRange) / oldRange) + newMin;
    return newValue;
}

// This method expects concentrationDose and IC50 to be in the same units
export function calculateDrugChannelBlockPercentage(concentrationDose, ic50Value, hValue) {
    return (1 - Math.pow(1 + Math.pow((concentrationDose / ic50Value), hValue), -1)) *100;
}
